import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ResponseMeta } from '../models/api.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'hg-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  public pageSize: number;
  public pageIndex: number;

  @Input()
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @Input()
  meta: ResponseMeta;

  @Output()
  pageSizeChange: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  pageChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  onPageChange(pageIndex: number) {
    this.pageChange.emit(pageIndex);
  }

  onPageSizeChange(pageSize: number) {
    this.pageSizeChange.emit(pageSize);
  }

}
